/**
 * Number format option objects for Intl.NumberFormat.
 *
 * Usage:
 *   import { usd, m2, m4 } from './helpers/number-formats.js';
 *   new Intl.NumberFormat('en-US', usd).format(1234.56);
 */

import { isAlera, isBW, isTBC } from './client-flags.js';

export const csp = ':&ensp;$&nbsp;';

export const usd = { style: 'currency', currency: 'USD' };
export const usp = { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 6 };

export const m0 = { minimumFractionDigits: 0, maximumFractionDigits: 0 };
export const m2 = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
export const m3 = { minimumFractionDigits: 3, maximumFractionDigits: 3 };
export const m4 = isAlera || isBW
	? { minimumFractionDigits: 4, maximumFractionDigits: 4 }
	: { minimumFractionDigits: 0, maximumFractionDigits: 4 };
export const m5 = { maximumFractionDigits: 5 };
export const m6 = isTBC
	? { minimumFractionDigits: 6, maximumFractionDigits: 6 }
	: { minimumFractionDigits: 0, maximumFractionDigits: 6 };
export const m8 = { maximumFractionDigits: 10 };

export const axconf = { headers: { 'X-Requested-With': 'XMLHttpRequest' }, resource_type: 'auto', withCredentials: false };

export const dateFormats = ['M/D/YY', 'MM/DD/YY', 'M/D/YYYY', 'MM/DD/YYYY', 'MMM D, YYYY', 'MMMM D, YYYY', 'MMM D YYYY', 'MMMM D YYYY', 'D MMM YYYY', 'YYYY-MM-DD', 'YYYY-M-D', 'D-MMM-YY', 'D-MMM-YYYY', 'DD-MMM-YYYY'];

export const imgTypes = 'image/bmp, image/gif, image/jpeg, image/x-citrix-jpeg, image/png, image/x-png, image/x-citrix-png, image/tiff';
export const xlsTypes =
	'text/plain, text/csv, application/excel, application/x-excel, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const docTypes =
	'text/plain, text/html, application/pdf, application/msword, application/excel, application/x-excel, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation';
export const mixTypes = imgTypes + ', ' + docTypes;

export let nthColor = ['#4eb5ac', '#a6dad5', '#ddfffd', '#dcdee0', '#9caea', '#808080'];
export let stdColor = ['#ffffff', '#f0f4f8', '#b2f5ea', '#243b53', '#000000'];
